<template>
  <div class="pt-5">
      <mdb-card>
        <mdb-card-body class="text-left">
          <div class="mb-4 border">
            <div id="text-wizard-area" class="grey lighten-5 border">
              <editor v-model="homeHtml" :init="editorConfig"></editor>
            </div>
          </div>

          <mdb-btn @click="save" icon="save" color="success">Save</mdb-btn>
          <mdb-btn @click="cancelEdit" icon="minus-circle" color="danger">Cancel</mdb-btn>
        </mdb-card-body>
      </mdb-card>
    </div>


</template>

<script>
import editor from '@tinymce/tinymce-vue'
import editorSettings from "../../services/editorSettings";
import api from "../../services/groupsPlaceApi";
import Avatar from "../common/Avatar";
import YesNoModal from "../common/YesNoModal";

import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbChip,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow,
} from 'mdbvue';
import Vue from "vue";

export default {
  name: 'group-branding-affiliates',
  components: {
    Avatar,
    mdbContainer, mdbBtn,
    mdbBadge,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbInput,
    mdbIcon,
    mdbChip,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbRow,
    mdbCol,
    YesNoModal,
    editor
  },
  props: {
    affiliate: {
      type: Object,
      default: null
    }
  },
  computed: {
    config: function () {
      return this.$store.state.settings
    }
  },
  data() {
    return {
      columns: [
        {label: "ID", field: "id"},
        {label: "Name", field: "name"}
      ],
      currentBrand: null,
      showBrand: false,
      showMain: true,
      changeGlobalGroupModal: false,
      homeHtml: null,
      showImageSelector: false,
      editorConfig: editorSettings.theWorksInline(),
    }
  },
  mounted() {
    this.homeHtml = JSON.parse(JSON.stringify(this.affiliate.homeHtml))
  },
  methods: {
    imageSelected: function (image) {
      this.showImageSelector = false
      let el = document.getElementsByClassName("tox-dialog-wrap")
      el[0].setAttribute("style", "display:block")
      Vue.nextTick().then(() => {
        this.imageCallback(image.url, {width: "33%", height: ""})
      })
    },
    myFileBrowser: function (callBack, value, meta) {
      let el = document.getElementsByClassName("tox-dialog-wrap")
      el[0].setAttribute("style", "display:none")
      Vue.nextTick().then(() => {
        this.showImageSelector = true
        this.imageCallback = callBack
      })
    },
    newBrand: function () {
      this.currentBrand = {
        id: null,
        name: "",
        globalGroupId: null,
        globalGroupName: null,
        affiliateCode: "",
        homeHtml: "",
        uriName: "",
        primaryOwnerId: null,
        primaryOwnerName: null,
        primaryOwnerAvatar: null
      }
      this.showMain = false
      this.showBrand = true
    },
    proxyOwner: function () {
      this.$router.push("/users/" + this.currentBrand.primaryOwnerId + "/proxy")
    },
    cancelEdit: function () {
      this.$emit("cancel")
    },
    save: function () {
      this.$store.dispatch("setExecuting", true)
      api.post("/affiliate/homeHtml/", {id: this.affiliate.id, homeHtml: this.homeHtml}).then(
        (results) => {
          this.$notify.success({message: "Saved", timeOut: 3000})
          this.$emit("saved", results.data.homeHtml)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
};

</script>
